module.exports = __webpack_public_path__ + "static/media/credit-card.68923378.svg";